import React from 'react';
import StepperButton from './StepperButton';
import ProgressLine from './ProgressLine';
import CardComponent from '../../../common/components/CardComponent';
import {getStepFromLabel} from './steps';
import {Step, steps} from '../../../types/Stepper';

interface StepperProps {
    title: string;
    status: Step | null;
    filterMessagesOnClick?: (label: Step) => void;
}

const Stepper = ({title, status, filterMessagesOnClick}: StepperProps) => {
    const step = status !== null ? getStepFromLabel(status) : 0;

    return (
        <CardComponent title={title}>
            <div className="d-flex flex-column align-items-start align-items-lg-center">
                <div className="d-flex flex-column flex-lg-row align-items-lg-center pb-lg-20 w-auto w-lg-100 justify-content-lg-center h-lg-250px">
                    {steps.map((button, index, row) => (
                        <React.Fragment key={button.label}>
                            <StepperButton
                                stepNumber={step}
                                buttonNumber={index + 1}
                                {...button}
                                {...(step === index + 1 && {size: 'large'})}
                                filterMessagesOnClick={filterMessagesOnClick}
                            />
                            {index + 1 < row.length && (
                                <ProgressLine stepNumber={step} buttonNumber={index + 1} />
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </CardComponent>
    );
};

export default Stepper;
